import type {Component, Editor} from 'grapesjs';

/** Which admin block to render. */
export enum AdminControlsScope {
  /** Per-component controls for a non-wrapper, non-section selection. */
  COMPONENT = 'component',
  /** Global controls shown on the empty state and the wrapper selection. */
  GLOBAL = 'global',
}

export interface EmailMakerAdminControlsProps {
  scope: AdminControlsScope;
  editor: Editor;
  /** Present only for the per-component scope. */
  component?: Component;
  /** Current template id from the immutable store; null until the first save. */
  idEmailTemplate: string | null;
}

/** Hardcoded English labels (admin-only UI is intentionally untranslated). */
export const ADMIN_CONTROLS_LABELS = {
  componentHeader: 'Admin component controls',
  globalHeader: 'Admin global controls',
  saveAsSectionTemplate: 'Save as section template',
  test: 'test',
  logProperties: 'Log properties',
  removeComponent: 'remove component',
  removeParent: 'remove parent',
  uploadCustomHtml: 'Upload custom HTML',
  checkImageSources: 'Check image sources',
  copyHtmlForMarketing: 'Copy HTML for Marketing',
  copyTextForMarketing: 'Copy TEXT for Marketing',
  copyMediaQueriesForMarketing: 'Copy Media Queries for Marketing',
  copyTextJson: 'Copy text JSON',
  openAdminTools: 'Open admin tools',
  desktopPreview: 'Desktop preview',
  tabletPreview: 'Tablet preview',
  phonePreview: 'Phone preview',
  logJson: 'log JSON',
  exposeEditor: 'Expose editor',
  fixWrapperWidth: 'Fix wrapper width',
} as const;

/** Icon class strings used by the admin buttons (matching legacy parity). */
export const ADMIN_CONTROLS_ICONS = {
  save: 'icon-save',
  rocket: 'icon-screen-rocket',
  copy: 'icon-copy',
  download: 'icon-download',
} as const;

export function selectionLabel(enabled: boolean): string {
  return `any selection: ${enabled ? 'enabled' : 'disabled'}`;
}

export function autosaveLabel(enabled: boolean): string {
  return `autosave: ${enabled ? 'enabled' : 'disabled'}`;
}
